import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Combos/getComboTodasUbicaciones`, method: 'GET', body: null})
}